<div class="grid-x margin-top">
  <div class="cell large-8 medium-8 small-9 padding-left">
    <span class="h4 bold">Landowner Pass-through Program Information</span> <help-text [helpText]="programInfo"></help-text>
  </div>
  @if (apiNumber && wellData) {
    <div class="cell large-4 medium-4 small-3">
      <label class="inline">Status:</label> {{ application.programStatus }}
    </div>
    <div class="cell large-6 medium-6 small-6 padding-left">
      <label class="inline">Date of Last Production:</label> {{ wellData.dateOfLastProduction | date: 'MM/dd/yyyy' }}
    </div>
    <div class="cell large-6 medium-6 small-6">
      <label class="inline">Last Owner Name:</label> {{ wellData.lastOwner }}
    </div>
    <div class="cell large-6 medium-6 small-6 padding-left">
      <label class="inline">Amount of Last Oil:</label> {{ wellData.amountOfLastOil | number }} bbls
    </div>
    <div class="cell large-6 medium-6 small-6">
      <label class="inline">Amount of Last Gas:</label> {{ wellData.amountOfLastGas | number }} mcf
    </div>
  } @else {
    @if (loading?.value == true) {
      <div class="cell large-12 medium-12 small-12 padding-left">
        <text-loader [run]="loading?.value == true" [text]="'Finding Landowner Pass-through Program applications'" [interval]="1000" [tickType]="'.'"></text-loader>
      </div>
    }
    @if (loading?.value == false) {
      <div class="cell large-12 medium-12 small-12 padding-left">
        No applications found.
      </div>
    }
  }
</div>


